import React from "react";
import "./style/footer.scss";
import footerLogo from "../../../assets/images/footer-logo.png";
import { TRANSLATIONS } from "../../../utils/constants";

const Footer: React.FC = () => {
  // Footer is intentionally locked to English regardless of the selected language.
  const S = TRANSLATIONS.en;
  return (
    <div className="footer-logo">
      {S.FOOTER.POWERED_BY}<img
        src={footerLogo}
        alt="Visitly"
        onError={(e) => {
          const img = e.currentTarget as HTMLImageElement;
          img.onerror = null;
          img.src = "/assets/images/footer-logo.png";
        }}
      />
    </div>
  );
};

export default Footer;
